import BaseTable from './base-table/index'
import EditTable from './edit-table/index'
import EditJsonTable from './edit-json-table/index'
import EditDivCell from './cell/index'
import DxyModal from './dxy-modal/index'
import Dtree from './tree/index'
import ContextMenu from './context-menu/index'
import HoverCard from './hover-card'
import SimplePopModal from './pop-modal/simple'
import SplitPane from './split-pane'
import ToolbarButton from './toolbar-button'
import { DxySteps, DxyStep } from './dxy-steps'
import { LeftRightContainer, LeftSlider } from './left-right-container'

const components = [
  BaseTable,
  EditTable,
  EditJsonTable,
  EditDivCell,
  DxyModal,
  Dtree,
  ContextMenu,
  HoverCard,
  SimplePopModal,
  SplitPane,
  ToolbarButton,
  DxySteps,
  DxyStep,
  LeftRightContainer,
  LeftSlider
]

const install = function (Vue) {
  if (install.installed) return
  components.map(component => Vue.component(component.name, component))
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  BaseTable,
  EditTable,
  EditJsonTable,
  EditDivCell,
  DxyModal,
  Dtree,
  ContextMenu,
  HoverCard,
  SimplePopModal,
  SplitPane,
  ToolbarButton,
  DxySteps,
  DxyStep,
  LeftRightContainer,
  LeftSlider
}
